// src/utils/ItemServicios.jsx
import Parcelas from "../modulo-ventas/productos/Parcelas";
import NichosColumbarios from "../modulo-ventas/productos/Columbarios";
import NichosAtaud from "../modulo-ventas/productos/NichosAtaud";

import Cremacion from "../modulo-ventas/servicios/Cremacion";
import Exequia from "../modulo-ventas/servicios/Exequia";
import Inhumacion from "../modulo-ventas/servicios/Inhumacion";
import Funerario from "../modulo-ventas/servicios/Funerarios";

const ItemServicios = ({
  tipoServicio,
  agregarAlPresupuesto,
  resetTrigger,
  deshabilitarBoton,
}) => {
  switch (tipoServicio) {
    case "parcelas":
      return (
        <Parcelas
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    case "cremacion":
      return (
        <Cremacion
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    case "honra-exequias":
      return (
        <Exequia
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    case "inhumacion-parcelas":
      return (
        <Inhumacion
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    case "nichos-ataud":
      return (
        <NichosAtaud
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    case "nichos-columbarios":
      return (
        <NichosColumbarios
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    case "plan-funerario":
      return (
        <Funerario
          agregarAlPresupuesto={agregarAlPresupuesto}
          resetTrigger={resetTrigger}
          deshabilitarBoton={deshabilitarBoton}
        />
      );
    default:
      return (
        <p style={{ textAlign: "center" }}>Seleccione un servicio válido.</p>
      );
  }
};

export default ItemServicios;
